import clsx from 'clsx'

interface Props {
  choices: { label: string; value: string }[]
  value: string
  onSelect(value: string): void
}

const GroupButton = ({ choices, value, onSelect }: Props) => {
  return (
    <div className='flex gap-1'>
      {choices.map((choice, index) => (
        <button
          key={choice.value}
          type='button'
          className={clsx(
            'outline-default hover:bg-fill-tertiary-hover active:bg-fill-tertiary-active px-4 py-1.5 text-sm whitespace-nowrap focus:appearance-none disabled:pointer-events-none',
            index == 0 ? 'rounded-l-lg' : index == choices.length - 1 ? 'rounded-r-lg' : '',
            value === choice.value ? 'bg-fill-tertiary-active font-bold' : 'bg-fill-tertiary'
          )}
          onClick={() => onSelect(choice.value)}
        >
          {choice.label}
        </button>
      ))}
    </div>
  )
}

export default GroupButton
